import React from "react"

import ApplicationInfo from "@/components/applicants/ApplicationInfo"
import AssessmentList from "@/components/applicants/AssessmentList"
import BookingsList from "@/components/applicants/BookingsList"
import DocumentsList, { type JobPostingStage } from "@/components/applicants/DocumentsList"
import DrivingLicenceSection from "@/components/applicants/DrivingLicenceSection"
import JobEmploymentDetails from "@/components/applicants/JobEmploymentDetails"
import TrialBlocksList from "@/components/applicants/TrialBlocksList"
import type { ApplicationDetails } from "@/hooks/useApplicationDetails"

import type { Tables } from "../../../database.types"

interface ApplicantDetailsMainProps {
  application: ApplicationDetails
  onViewDocument: (document: Tables<"documents">) => void
  onEditApplicant?: () => void
  onScheduleOrientation?: () => void
  onScheduleVehicleCollection?: () => void
  onRescheduleOrientation?: (bookingId: string) => void
  onRescheduleVehicleCollection?: (bookingId: string) => void
}

const ApplicantDetailsMain = ({
  application,
  onViewDocument,
  onEditApplicant,
  onScheduleOrientation,
  onScheduleVehicleCollection,
  onRescheduleOrientation,
  onRescheduleVehicleCollection,
}: ApplicantDetailsMainProps) => {
  const documents = application.documents ?? []
  const allowedStages: JobPostingStage[] = application.allowed_stages ?? []

  return (
    <div className="space-y-6">
      <ApplicationInfo application={application} onEdit={onEditApplicant} />

      <JobEmploymentDetails job={application.job} />

      <DrivingLicenceSection driverLicenceRecords={application.driver_licence_records} />

      <AssessmentList assessments={application.assessments} />

      <DocumentsList
        jobStages={allowedStages}
        documents={documents}
        onViewDocument={onViewDocument}
      />

      <TrialBlocksList trialBlocks={application.trial_blocks} />

      <BookingsList
        applicationId={application.id}
        orientationBookings={application.orientation_bookings}
        vehicleBookings={application.vehicle_bookings}
        onScheduleOrientation={onScheduleOrientation}
        onScheduleVehicleCollection={onScheduleVehicleCollection}
        onRescheduleOrientation={onRescheduleOrientation}
        onRescheduleVehicleCollection={onRescheduleVehicleCollection}
      />
    </div>
  )
}

export default ApplicantDetailsMain
